const parseUrl = (url: string) => {
  let urlObject = document.createElement('a');
  urlObject.href = url;
  return {
    href: urlObject.href,
    pathname: urlObject.pathname,
    search: urlObject.search,
    hostname: urlObject.hostname,
    protocol: urlObject.protocol,
  };
};
const cleanUrl = (url: string): string => {
  let urlObject = document.createElement('a');
  urlObject.href = url;
  return urlObject.href;
};

enum HistoryServiceEvents {
  HISTORY_SERVICE_CHANGED = 'history_service_changed',
}

class HistoryServiceClass {
  constructor() {
    window.addEventListener('popstate', _ => this.dispatchHistoryEvent());
  }

  add(url: string) {
    const currentLocation = parseUrl(window.location.href);
    let targetLocation = parseUrl(cleanUrl(url));
    if (currentLocation.href !== targetLocation.href) {
      window.history.pushState({}, '', targetLocation.href);
      this.dispatchHistoryEvent();
    }
  }

  addArgumentToUrl(url: string, queryParams: { [key: string]: string }) {
    const { search, pathname } = parseUrl(url);
    const urlParams = new URLSearchParams(search);
    Object.keys(queryParams).forEach(key => urlParams.set(key, queryParams[key]));
    this.add(pathname + '?' + urlParams.toString());
    window.dispatchEvent(new PopStateEvent('popstate'));
  }

  protected dispatchHistoryEvent() {
    const detail = {
      detail: window.location.href,
    };
    window.dispatchEvent(new CustomEvent(HistoryServiceEvents.HISTORY_SERVICE_CHANGED, detail));
  }
}

export const HistoryService = new HistoryServiceClass();
